export { ocrQueries, ocrKeys } from './services/ocr.queries';
export {
  useStartOcrMutation,
  useUpdateOcrFieldMutation,
  useAcceptOcrFieldMutation,
  useAcceptAllOcrFieldsMutation,
  useAcceptAllOcrFieldsOnPageMutation,
  useRetryOcrMutation,
  useRetryFailedOcrBatchesMutation,
  usePauseOcrContainerMutation,
  useResumeOcrContainerMutation,
  useRecoverOcrContainerMutation,
  useRerunOcrPageMutation
} from './services/ocr.mutations';
export { StartOcrButton } from './components/start-ocr-button';
export { OcrResultsPage } from './components/ocr-results-page';
export { useOcrResultPolling } from './hooks/use-ocr-result-polling';
export { ContainerOcrPanel } from './components/container-ocr-panel';
export { ContainerResultsSheet } from './components/container-results-sheet';
export { ContainerResultsOverlay } from './components/container-results-overlay';
export { OcrContainersListing } from './components/ocr-containers-listing';
// The start-OCR template picker. Exported (unmodified) because the results
// page needs the same dialog the containers listing opens — a second copy
// would be a second precedence rule for which templates a run uses.
export { OcrTemplatePoolDialog } from './components/ocr-template-pool-dialog';
export { DocumentPagesViewer } from './components/document-pages-viewer';
export { ExtractedFieldCard } from './components/extracted-field-card';
export { OcrErrorCard } from './components/ocr-error-card';
export { FailedBatchesCallout } from './components/failed-batches-callout';
export { OcrProgressBar } from './components/ocr-progress-bar';
export { ActiveOcrJobsBadge } from './components/active-ocr-jobs-badge';
export { useActiveOcrJobs } from './hooks/use-active-ocr-jobs';
export { useOcrUserChannel } from './hooks/use-ocr-user-channel';
export { useOcrToast } from './utils/ocr-toast';
export { useFieldHighlightColors } from './hooks/use-field-highlight-colors';
export { resolveFieldHighlightColor } from './utils/highlight-color';
// Which physical pages one OcrResult actually covers. Exported because the QA
// verdict dialogs must file a rejection reason against a page the result
// really owns — `pages` is the whole container's list on every result, so it
// cannot answer that question.
export { resolveOwnedPages, type OwnedPage } from './utils/owned-pages';
export { legacyViewerPage } from './utils/legacy-viewer-page';
export type { ViewerPage } from './components/document-pages-viewer';
export type {
  OcrContainerSummary,
  OcrContainerSummaryTemplate,
  OcrResult,
  OcrResultStatus,
  OcrQaStage,
  OcrQaPageReview,
  OcrQaReview,
  OcrProgressStage,
  OcrErrorCode,
  DocumentChunk,
  ExtractedDataItem,
  ExtractedFieldSource,
  ChunkType,
  BBox,
  UpdateFieldRequest,
  ActiveOcrJob,
  OcrJobLifecyclePayload,
  OcrResultStatusPayload
} from './types';
